module.exports = __webpack_public_path__ + "static/media/logoV2.31a17964.svg";